import "./EmailLogin.scss"
import React, { useState } from "react"
import {
  Button,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import {
  loginEmailAsync,
  getUserAsync,
  selectRememberMe,
  setRememberMe,
} from "../../../redux/slices/authSlice"
import { useNavigate } from "react-router-dom"
import avatarIcon from "../../../assets/images/avatar.png"
import lockIcon from "../../../assets/images/lock-icon.png"
import OpenEye from "../../../assets/icons/OpenEye"
import CloseEye from "../../../assets/icons/CloseEye"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import AppInput from "../../../components/AppInput/AppInput.component"
import useFormValidation from "../../../hooks/useFormValidation"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import Loader from "../../../components/Loader/Loader.component"
import { ROUTES } from "../../../config/routes.const"
import { useValidationSchemas } from "../../../hooks/useIsValidationScehemes"
import { useBranding } from "../../../hooks/useBranding"
import { useIsGoTo } from "../../../hooks/useIsGoTo"
import { t } from "i18next"

const EmailLogin = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const rememberMe: boolean = useAppSelector(selectRememberMe)
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const {
    LOGIN,
    INPUT_EMAIL,
    INPUT_PASSWORD,
    LOGIN_ERROR,
    FORGOT_PASSWORD,
    REMEMBER_ME,
  } = useTranslationLabel()

  const handleRememberMeChange = (event: any) => {
    dispatch(setRememberMe(event.target.checked))
  }
  const { emailLoginSchema } = useValidationSchemas()
  const { join, registrationLink } = useBranding();
  const {isGoTo } = useIsGoTo();

  const emailFormDataInitial = { email: "", password: "" }
  const {
    formData: emailFormData,
    errors: emailErrors,
    handleChange: handleEmailChange,
    validateForm: validateEmailForm,
  } = useFormValidation(emailFormDataInitial, emailLoginSchema)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true)

    if (validateEmailForm()) {
      const { email, password } = emailFormData
      await dispatch(loginEmailAsync({ email, password }))
        .unwrap()
        .then(async () => {
          await dispatch(getUserAsync()).then(() => {
            navigate(ROUTES.ACCOUNT)
          })
        })
        .catch((err) => {
          dispatch(
            showModal({
              activeModal: ModalTypes.SIMPLE_MODAL,
              data: {
                className: "error-modal",
                description: LOGIN_ERROR,
              },
            }),
          )
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  return (
    <div className="email-login-container">
      {loading && <Loader />}
      <form onSubmit={handleSubmit} className={"form column center"}>
        <div className="form-group column email">
          <AppInput
            label={INPUT_EMAIL}
            name="email"
            className="email"
            value={emailFormData.email}
            onChange={handleEmailChange}
            error={emailErrors.email}
            startAdornment={
              <InputAdornment position="start">
                <img src={avatarIcon} className="avatar-icon" alt="" />
              </InputAdornment>
            }
          />

          <AppInput
            label={INPUT_PASSWORD}
            type={showPassword ? "text" : "password"}
            name="password"
            className="password"
            value={emailFormData.password}
            onChange={handleEmailChange}
            error={emailErrors.password}
            startAdornment={
              <InputAdornment position="start">
                <img src={lockIcon} className="lock-icon" alt="logo" />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() =>
                    setShowPassword((prevShowPassword) => !prevShowPassword)
                  }
                >
                  {showPassword ? <OpenEye /> : <CloseEye />}
                </IconButton>
              </InputAdornment>
            }
          />
        </div>
        {isGoTo && <div className="form-options column center">
          <a
            href={registrationLink}
            target="_blank"
          >
            {t(join)}
          </a>
        </div>}
        <div className="form-options column center">
          <FormControlLabel
            control={
              <Checkbox
                checked={!!rememberMe}
                onChange={handleRememberMeChange}
              />
            }
            label={REMEMBER_ME}
          />
          <a
            // href="/"
            onClick={() =>
              dispatch(
                showModal({ activeModal: ModalTypes.FORGOT_PASSWORD_MODAL }),
              )
            }
          >
            {FORGOT_PASSWORD}
          </a>
        </div>
        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          className="primary-btn"
        >
          {LOGIN}
        </Button>
      </form>
    </div>
  )
}
export default EmailLogin
